import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'ekipman-kontrol-listesi',
  href: '/araclar/ekipman-kontrol-listesi',
  title: 'Ekipman Kontrol Listesi',
  shortLabel: 'Ekipman',
  eyebrow: '28628 sayılı İş Ekipmanları Yönetmeliği',
  description:
    'Forklift, vinç, kompresör, merdiven gibi ekipmanlar için periyodik kontrol listesi oluşturun. Hazır şablonlardan seçin, kendi maddelerinizi ekleyin, imzaya hazır PDF üretin.',
  bullets: [
    'Hazır şablon kütüphanesi',
    'Kendi maddenizi ekleyin / silin',
    'Firma + bölüm + kontrolü yapan',
    'PDF rapor (imza alanlı)',
  ],
  audience: 'İş güvenliği uzmanı · Bakım sorumlusu · Saha denetçisi',
  icon: ClipboardDocumentListIcon,
  mevzuat: [
    { no: '28628', ad: 'İş Ekipmanlarının Kullanımında Sağlık ve Güvenlik Şartları Yönetmeliği' },
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu' },
  ],
  imzaTipi: 'TEK',
  raporlama: 'PDF',
  pdfEndpoint: '/api/equipment-checklist/report/pdf',
  faqs: [
    {
      question: 'Bu kontrol listesini kim doldurur?',
      answer:
        'Bu araç işletme içi öz-kontrol içindir; ekipmanı kullanan operatör, bakım sorumlusu veya iş güvenliği uzmanı vardiya başı / kullanım öncesi kontrolde doldurur. Yasal yıllık periyodik muayene ise ayrı bir süreçtir: 28628 sayılı Yönetmelik gereği yetkili kişiler yapar (kaldırma/iletme ekipmanları için makine mühendisi veya teknik öğretmen, basınçlı kaplar için makine/kimya mühendisi, elektrik tesisatları için elektrik mühendisi).',
    },
    {
      question: 'Bu liste resmî periyodik kontrol yerine geçer mi?',
      answer:
        'Hayır. Bu araç günlük/haftalık operasyonel kontrol listesi (vardiya başı kontrolü, kullanım öncesi check) için tasarlanmıştır. Yıllık periyodik muayene yetkili teknik kişiler tarafından ayrıca yapılmalıdır.',
    },
  ],
  seo: {
    title: 'Ekipman Kontrol Listesi Oluşturucu — Forklift, Vinç PDF',
    description:
      '28628 sayılı İş Ekipmanları Yönetmeliği uyumlu periyodik kontrol listesi. Forklift, vinç, kompresör, merdiven şablonları + kendi maddenizi ekleme. İmzalı PDF. Ücretsiz.',
    keywords:
      'ekipman kontrol listesi, periyodik kontrol, forklift kontrol, vinç kontrol, iş ekipmanları yönetmeliği',
    canonicalPath: '/araclar/ekipman-kontrol-listesi',
    featureList: [
      "Ekipman kategorisini aranabilir listeden seçme",
      "Seçilen kategoriye ait hazır kontrol maddelerini getirme",
      "Kendi kontrol maddenizi ilgili standartla ekleme",
      "Şablon kütüphanesinde madde arama ve toplu ekleme",
      "Kontrol tarihi, firma, bölüm ve kontrolü yapan kişi bilgilerini girme",
      "Uygun / Uygun Değil / Uygulanamaz kutucuklu, imzaya hazır A4 PDF kontrol listesi",
      "Ücretsiz, kayıt gerektirmez",
    ],
    lastmod: '2026-08-08',
    priority: '0.8',
    changefreq: 'monthly',
  },
  order: 70,
  enabled: true,
  launchedAt: '2025-09-01',
  topics: ['ekipman', 'is-ekipman', 'periyodik-kontrol', 'makine', 'forklift', 'vinc', 'kompresor', 'jenerator', 'kontrol-listesi', '28628', 'is-ekipmanlari-yonetmeligi'],
  intent: 'rehber',
  spamCapacity: 3,
  bridge: {
    href: '/isg-yazilimi',
    etiket: 'Periyodik kontrolleri ekipman bazında dijital takip edin',
  },
};

export default manifest;
